/**
 * Entry point for the client-side application.
 * Take the pre-rendered HTML and add interactivity.
 */

import { h, render } from 'preact'; /** @jsx h */
import { hydrate } from 'preact-iso';



import { Client } from './app/Client';
import './style/main.scss';




declare const window: any;

//console.log('window domain', window?.__DOMAIN__);

const WebApp = () => <Client
    devSubdomain="pyqml"
    domain={typeof window ? window?.__DOMAIN__ : undefined}
    dataUrl={typeof window ? window?.__DEV_CLOUD_API__ ?? undefined : undefined}
    apis={{
        //devCloudApi: typeof window ? window?.__DEV_CLOUD_API__ ?? undefined : undefined,
        //apiExample: typeof window ? window?.__API_EXAMPLE__ : undefined
    }}
    nodeEnv={typeof window ? window?.__NODE_ENV__ : undefined}
    //ssrCache={typeof window ? window?.__SSR_CACHE__ : undefined}
/>;

const rootElement = document.getElementById('root');
if (rootElement) {
    if (rootElement?.hasChildNodes()) {
        hydrate(<WebApp />);
    } else {
        render(<WebApp/>, rootElement);
    }
};